import React, { useState, useEffect } from 'react';
import apiClient from '../api/apiClient';
import DataTable from '../components/DataTable';
import CreateUserModal from '../components/CreateUserModal';
import './UserManagementPage.css'; // Husk CSS filen
import { useAuth } from '../context/AuthContext';

const UserManagementPage = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState(''); // Ny state til søgning
  const [centers, setCenters] = useState([]);
  const { user } = useAuth();

  useEffect(() => {
    fetchUsers();
    if (user?.role === 'ADMIN') {
      apiClient.get('/api/sprogcentre').then((res) => setCenters(res.data)).catch(console.error);
    }
  }, [user]);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await apiClient.get('/api/users');
      setUsers(res.data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  //Håndter admin reset
  const handleForceReset = async (userId, userName) => {
    // 1. Bed admin om det nye kodeord
    const newPassword = window.prompt(`Indtast nyt kodeord for ${userName}:`, "Velkommen123");

    if (newPassword) {
      try {
        await apiClient.put(`/api/users/${userId}/force-password`, { newPassword });
        alert(`Succes! Kodeordet for ${userName} er nu ændret.`);
      } catch (err) {
        alert(err.response?.data?.message || 'Fejl ved ændring af kodeord.');
      }
    }
  };

  const handleCreate = async (data) => {
    try {
      const res = await apiClient.post('/api/users', data);

      // Hent listen igen for at være sikker på at alle joins (navne) er med, 
      // eller lav en manuel patch som vi gjorde på StaffPage hvis du vil optimere.
      // Her henter vi bare listen igen for nemheds skyld:
      fetchUsers();

      setShowModal(false);
      alert(`Bruger oprettet!\nEmail: ${res.data.email}\nMidlertidig kode: Velkommen123`);
    } catch (err) {
      alert(err.response?.data?.message || 'Fejl ved oprettelse');
    }
  };

  // Filtreringslogik
  const filteredUsers = users.filter(user => {
    // 1. Gør søgeteksten lille og fjern mellemrum i enderne
    const search = searchTerm.toLowerCase().trim();
    
    if (!search) return true; // Vis alt hvis søgefelt er tomt

    // 2. Hent værdier sikkert (håndter null/undefined)
    const fName = (user.first_name || '').toLowerCase();
    const lName = (user.last_name || '').toLowerCase();
    const fullName = `${fName} ${lName}`;
    
    const email = (user.email || '').toLowerCase();
    const roles = (user.roles || [user.role]).filter(Boolean).join(' ').toLowerCase();
    const centers = (user.sprogcentre || []).join(' ').toLowerCase();

    // 4. Tjek om søgeordet findes i NOGEN af felterne
    return (
      fullName.includes(search) || 
      email.includes(search) ||
      roles.includes(search) ||
      centers.includes(search)
    );
  });

  // Helper til badge style
  const getRoleClass = (role) => {
    if (role === 'ADMIN') return 'role-admin';
    if (role === 'SC_ADMIN') return 'role-sc-admin';
    if (role === 'CENSOR') return 'role-censor';
    if (role === 'TEACHER') return 'role-teacher';
    return 'role-teacher';
  };

  // DEFINER KOLONNER
  const columns = [
    { header: 'Navn', width: '20%', render: r => <strong>{r.first_name} {r.last_name}</strong> },
    { header: 'Email', width: '25%', accessor: 'email' },
    {
      header: 'Roller', width: '20%',
      render: r => (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
          {(r.roles || [r.role]).filter(Boolean).map(role => (
            <span key={role} className={`role-badge ${getRoleClass(role)}`}>{role}</span>
          ))}
        </div>
      )
    },
    {
      header: 'Sprogcentre', width: '20%',
      render: r => r.sprogcentre?.join(', ') || 'System'
    },
    {
      header: 'Handling', width: '20%', align: 'right', // Gør plads til knappen
      render: r => (
        <div style={{ display: 'flex', gap: '5px', justifyContent: 'flex-end' }}>

          {/* Skift Kodeord */}
          {user?.role === 'ADMIN' && (
            <button
              onClick={() => handleForceReset(r.id, `${r.first_name} ${r.last_name}`)}
              className="edit-btn"
              title="Sæt nyt kodeord for brugeren"
              style={{ color: '#d69e2e', borderColor: '#d69e2e' }} // Gul/Guld farve for "Nøgle"
            >
              🔑 Kode
            </button>
          )}
        </div>
      )
    }
  ];

  return (
    <div>

      <div className="table-card">

        {/* HEADER CONTENT: Søgning og Knap */}
        <div className="card-header-content">
          <div className="filter-bar-right">
            <input
              type="text"
              className="search-input"
              placeholder="Søg bruger..."
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
            />
            <button className="action-btn" onClick={() => setShowModal(true)}>+ Opret Bruger</button>
          </div>
        </div>

        {/* TABEL */}
        <DataTable
          columns={columns}
          data={filteredUsers}
          loading={loading}
          noDataMessage="Ingen brugere fundet."
          initialSortKey="first_name"
        />
      </div>

      {showModal && (
        <CreateUserModal
          onClose={() => setShowModal(false)}
          onCreate={handleCreate}
          user={user}
          centers={centers}
        />
      )}
    </div>
  );
};

export default UserManagementPage;
